import styled from 'styled-components';

const Asterisk = styled.span`
  color: red;
  font-size: 20px;
  position: absolute;
`;

export default Asterisk;
